/**
 * ESA Component: Event Controller (Site)
 * -------------------------------------------------------------
 * @copyright (c) 2026 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"

class EventController extends Controller {
  static CID = 'event'
  static NAME = 'Event'

  initiate() {
    super.initiate();

    const registerFields = document.querySelectorAll('[data-esa-register-field]') || null;
    if (registerFields) {
      registerFields.forEach(field => field.addEventListener('change', ({ target }) => {
          let link = target.dataset.esaRegisterLink;
          let fieldName = target.dataset.esaRegisterField;
          let fieldValue = target.value || '';
          if (link && fieldName && fieldValue) {
            link += "?" + encodeURIComponent(fieldName) + "=" + encodeURIComponent(fieldValue) + '&' + Joomla.getOptions("csrf.token") + "=1";
            document.location.href = link;
          }
        })
      );
    }
  }
}

export default EventController
